import d from "@babel/runtime/helpers/esm/objectSpread2";
import S from "@babel/runtime/helpers/esm/classCallCheck";
import c from "@babel/runtime/helpers/esm/createClass";
import x from "@babel/runtime/helpers/esm/inherits";
import C from "@babel/runtime/helpers/esm/createSuper";
import o from "@babel/runtime/helpers/esm/defineProperty";
import { sstyled as z } from "@semcore/utils/lib/core/index";
import v, { sstyled as u, assignProps as y, Component as k } from "@semcore/core";
import r from "react";
import { Box as b } from "@semcore/flex-box";
import w from "@semcore/utils/lib/enhances/resolveColorEnhance";
import P from "@semcore/utils/lib/enhances/i18nEnhance";
import { localizedMessages as E } from "./translations/__intergalactic-dynamic-locales.mjs";
var R = (
  /*__reshadow_css_start__*/
  (z.insert(
    /*__inner_css_start__*/
    "@keyframes spin-rotate_ofphm{0%{transform:rotate(0deg)}to{transform:rotate(360deg)}}.___SSpin_ofphm_gg_{display:block;flex-shrink:0;box-sizing:border-box;animation-name:spin-rotate_ofphm;animation-iteration-count:infinite;animation-timing-function:linear;animation-duration:.75s;fill:var(--theme_ofphm)}.___SSpin_ofphm_gg_._theme_dark_ofphm_gg_{fill:var(--intergalactic-border-primary, #c4c7cf)}.___SSpin_ofphm_gg_._theme_invert_ofphm_gg_{fill:var(--intergalactic-border-primary-invert, #ffffff)}.___SSpin_ofphm_gg_.__centered_ofphm_gg_{margin:auto}.___SSpin_ofphm_gg_._size_xs_ofphm_gg_{width:16px;height:16px}.___SSpin_ofphm_gg_._size_s_ofphm_gg_{width:20px;height:20px}.___SSpin_ofphm_gg_._size_m_ofphm_gg_{width:24px;height:24px}.___SSpin_ofphm_gg_._size_l_ofphm_gg_{width:32px;height:32px}.___SSpin_ofphm_gg_._size_xl_ofphm_gg_{width:48px;height:48px}.___SSpin_ofphm_gg_._size_xxl_ofphm_gg_{width:72px;height:72px}@media (prefers-reduced-motion){.___SSpin_ofphm_gg_{animation-name:none}}",
    "ofphm_gg_"
  ), {
    "@spin-rotate": "spin-rotate_ofphm",
    __SSpin: "___SSpin_ofphm_gg_",
    "--theme": "--theme_ofphm",
    _theme_dark: "_theme_dark_ofphm_gg_",
    _theme_invert: "_theme_invert_ofphm_gg_",
    _centered: "__centered_ofphm_gg_",
    _size_xs: "_size_xs_ofphm_gg_",
    _size_s: "_size_s_ofphm_gg_",
    _size_m: "_size_m_ofphm_gg_",
    _size_l: "_size_l_ofphm_gg_",
    _size_xl: "_size_xl_ofphm_gg_",
    _size_xxl: "_size_xxl_ofphm_gg_"
  })
), i = /* @__PURE__ */ function(p) {
  x(_, p);
  var m = C(_);
  function _() {
    return S(this, _), m.apply(this, arguments);
  }
  return c(_, [{
    key: "render",
    value: function() {
      var n = this.asProps, t, g = b, e = this.asProps, s = e.Children, a = e.styles, h = e.theme, f = e.resolveColor, l = e.getI18nText;
      return t = u(a), /* @__PURE__ */ r.createElement(g, t.cn("SSpin", d({}, y({
        tag: "svg",
        viewBox: "0 0 24 24",
        "use:theme": f(h),
        role: "img",
        "aria-label": l("loading")
      }, n))), /* @__PURE__ */ r.createElement("path", t.cn("path", {
        d: "M16.98 20.6256C17.5433 21.6013 18.8054 21.9477 19.6718 21.2274C21.567 19.6517 22.9447 17.5183 23.5911 15.1058C24.4148 12.0317 23.9836 8.75621 22.3923 6C20.801 3.24379 18.18 1.23261 15.1058 0.408891C12.6934 -0.237529 10.1569 -0.111098 7.84473 0.742337C6.78777 1.13246 6.45667 2.39867 7.02 3.37439V3.37439C7.58333 4.3501 8.83088 4.65471 9.91792 4.35856C11.2588 3.99325 12.6844 3.984 14.0498 4.34987C16.0788 4.89352 17.8087 6.2209 18.8589 8.04C19.9092 9.8591 20.1938 12.0209 19.6501 14.0498C19.2843 15.4153 18.5634 16.6453 17.5766 17.6239C16.7766 18.4172 16.4167 19.6499 16.98 20.6256V20.6256Z"
      })), /* @__PURE__ */ r.createElement(s, t.cn("Children", {})));
    }
  }]), _;
}(k);
o(i, "displayName", "Spin");
o(i, "style", R);
o(i, "enhance", [w(), P(E)]);
o(i, "defaultProps", {
  size: "m",
  theme: "dark"
});
const H = v(i);
export {
  H as default
};
